module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8n5r1r-a974aefc3a8a5b33d9971c0cc936836e.svg";